export const courseValue = [
    {
        value: 'COURSE - 497038 - 2020 Combined Anti-Trust and Anti-Corruption Training co-located with BPR [CLO Sponsored]',
        name: 'COURSE - 497038 - 2020 Combined Anti-Trust and Anti-Corruption Training co-located with BPR [CLO Sponsored]'
    },
    {
        value: 'COURSE - 6001 - Business Practices Review (BPR) [CLO Sponsored]',
        name: 'COURSE - 6001 - Business Practices Review (BPR) [CLO Sponsored]'
    }
]